module.exports = __webpack_public_path__ + "static/media/logo_tappx.2bfe9587.png";